import React, { useEffect, useState } from "react";
import { Container, StyledItem } from "./styles";
import { getLineItemsTitle } from 'src/helpers/cartList.js'

interface Props {
  items: any[];
  className?: string;
}

const CartList = ({ items, className }: Props) => {
  if (items.length <= 0) return null;

  const [mappedItems, setMappedItems] = useState(items);

  useEffect(() => {
    getLineItemsTitle(items)
    .then(res => setMappedItems(res));
  }, [items])

  return (
    <Container className={className}>
      {mappedItems.map((item: any) => (
        <StyledItem totalItems={mappedItems?.length} key={item.id} loadOldImage={true} cartTitle={item.content?.main.cartTitle} {...item} />
      ))}
    </Container>
  )
}

export default CartList;
